import axiosClient from '../api/AxiosConfig';

export const BookingService = {
  GetBookings: async (filter) => (await axiosClient.get('/booking', { params: { ...filter } })).data,
};
